<template>
	<div class="app-container">
		<!-- <div class="page-header">
			<div class="header-left">
				<h2>用户详情</h2>
				<el-tag type="info" class="user-id">ID: {{ userForm.id }}</el-tag>
			</div>
			<div class="header-actions">
				<el-button @click="goBack">
					<el-icon>
						<Back />
					</el-icon> 返回
				</el-button>
				<el-button type="primary" @click="handleSave" :loading="saveLoading">
					<el-icon>
						<Check />
					</el-icon> 保存
				</el-button>
			</div>
		</div> -->
		<el-card class="filter-card" shadow="hover">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleSave" :loading="saveLoading">
						<el-icon>
							<Check />
						</el-icon> 保存
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-row :gutter="20">
			<el-col :md="24" :lg="12">
				<el-card class="detail-card" shadow="hover">
					<template #header>
						<div class="card-header">
							<span class="header-title">基本信息</span>
							<el-tag type="success" effect="plain" v-if="userForm.username">已激活</el-tag>
						</div>
					</template>

					<el-form ref="formRef" :model="userForm" :rules="rules" label-width="100px" v-loading="loading"
						class="user-form">
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="用户名" prop="username">
									<el-input v-model="userForm.username" placeholder="请输入用户名" disabled
										class="disabled-input">
										<template #prefix>
											<el-icon>
												<User />
											</el-icon>
										</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="手机号" prop="mobile">
									<el-input v-model="userForm.mobile" placeholder="请输入手机号">
										<template #prefix>
											<el-icon>
												<Phone />
											</el-icon>
										</template>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="邮箱" prop="email">
									<el-input v-model="userForm.email" placeholder="请输入邮箱">
										<template #prefix>
											<el-icon>
												<Message />
											</el-icon>
										</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="部门" prop="deptId">
									<el-tree-select v-model="userForm.deptId" :data="departmentTree"
										:props="{ value: 'deptId', label: 'deptName' }" placeholder="请选择部门"
										check-strictly :render-after-expand="false" @change="handleDepartmentChange"
										class="department-select">
										<template #prefix>
											<el-icon>
												<Office />
											</el-icon>
										</template>
									</el-tree-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="职位" prop="position">
									<el-input v-model="userForm.position" placeholder="请输入职位">
										<template #prefix>
											<el-icon>
												<Briefcase />
											</el-icon>
										</template>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-card>
			</el-col>
			<el-col :md="24" :lg="12">
				<el-card class="detail-card" shadow="hover">
					<template #header>
						<div class="card-header">
							<span class="header-title">修改密码</span>
							<el-tag type="warning" effect="plain">可选</el-tag>
						</div>
					</template>

					<el-form ref="passwordFormRef" :model="userForm" :rules="rules" label-width="100px"
						class="password-form">
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="新密码" prop="newPassword">
									<el-input v-model="userForm.newPassword" type="password" placeholder="请输入新密码"
										show-password>
										<template #prefix>
											<el-icon>
												<Lock />
											</el-icon>
										</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="确认密码" prop="confirmPassword">
									<el-input v-model="userForm.confirmPassword" type="password" placeholder="请确认新密码"
										show-password>
										<template #prefix>
											<el-icon>
												<Lock />
											</el-icon>
										</template>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
		<!-- <el-card class="detail-card" shadow="hover">
			<template #header>
				<div class="card-header">
					<span class="header-title">基本信息</span>
					<el-tag type="success" effect="plain" v-if="userForm.username">已激活</el-tag>
				</div>
			</template>

			<el-form ref="formRef" :model="userForm" :rules="rules" label-width="100px" v-loading="loading"
				class="user-form">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="用户名" prop="username">
							<el-input v-model="userForm.username" placeholder="请输入用户名" disabled class="disabled-input">
								<template #prefix>
									<el-icon>
										<User />
									</el-icon>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号" prop="mobile">
							<el-input v-model="userForm.mobile" placeholder="请输入手机号">
								<template #prefix>
									<el-icon>
										<Phone />
									</el-icon>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="userForm.email" placeholder="请输入邮箱">
								<template #prefix>
									<el-icon>
										<Message />
									</el-icon>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="部门" prop="deptId">
							<el-tree-select v-model="userForm.deptId" :data="departmentTree"
								:props="{ value: 'deptId', label: 'deptName' }" placeholder="请选择部门" check-strictly
								:render-after-expand="false" @change="handleDepartmentChange" class="department-select">
								<template #prefix>
									<el-icon>
										<Office />
									</el-icon>
								</template>
							</el-tree-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="职位" prop="position">
							<el-input v-model="userForm.position" placeholder="请输入职位">
								<template #prefix>
									<el-icon>
										<Briefcase />
									</el-icon>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-card> -->

		<!-- <el-card class="detail-card" shadow="hover">
			<template #header>
				<div class="card-header">
					<span class="header-title">修改密码</span>
					<el-tag type="warning" effect="plain">可选</el-tag>
				</div>
			</template>

			<el-form ref="passwordFormRef" :model="userForm" :rules="rules" label-width="100px" class="password-form">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="新密码" prop="newPassword">
							<el-input v-model="userForm.newPassword" type="password" placeholder="请输入新密码" show-password>
								<template #prefix>
									<el-icon>
										<Lock />
									</el-icon>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="确认密码" prop="confirmPassword">
							<el-input v-model="userForm.confirmPassword" type="password" placeholder="请确认新密码"
								show-password>
								<template #prefix>
									<el-icon>
										<Lock />
									</el-icon>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-card> -->

		<el-card class="detail-card" shadow="hover">
			<template #header>
				<div class="card-header">
					<span class="header-title">年度计划</span>
					<div class="header-right">
						<el-tag type="info" effect="plain">当前年度：{{ new Date().getFullYear() }}</el-tag>
						<el-button type="primary" size="small" @click="handleEditTarget" v-if="userForm.target">
							<el-icon>
								<Edit />
							</el-icon> 编辑目标
						</el-button>
					</div>
				</div>
			</template>

			<div v-loading="planLoading">
				<template v-if="userForm.target">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="年度目标金额">
							{{ formatAmount(userForm.target.annualTarget) }}
						</el-descriptions-item>
						<!-- <el-descriptions-item label="月度目标金额">
              {{ formatAmount(annualPlan.annualTarget / 12) }}
            </el-descriptions-item> -->
					</el-descriptions>

					<h3 style="margin: 20px 0 10px;">月度目标明细</h3>
					<div class="monthly-grid">
						<div v-for="month in 12" :key="month" class="monthly-item">
							<div class="month-label">{{ month }}月</div>
							<div class="month-amount">{{formatAmount(userForm.target.monthlyTargets1[month-1])}}
								/{{ formatAmount(userForm.target.monthlyTargets[month-1]) }}</div>
							<div class="month-percentage">
								{{ ((userForm.target.monthlyTargets1[month-1] / userForm.target.monthlyTargets[month-1]) * 100).toFixed(2) }}%
							</div>
						</div>
					</div>
				</template>
				<el-empty v-else description="暂无年度计划数据"></el-empty>
			</div>
		</el-card>

		<!-- 编辑目标对话框 -->
		<el-dialog title="编辑年度目标" v-model="targetDialogVisible" width="800px" :close-on-click-modal="false">
			<el-form ref="targetFormRef" :model="targetForm" :rules="targetRules" label-width="120px"
				v-loading="targetLoading">
				<!-- <el-form-item label="年度目标金额" prop="annualTarget">
          <el-input-number
            v-model="targetForm.annualTarget"
            :min="0"
            :precision="2"
            :step="1000"
            style="width: 200px"
            @change="handleAnnualTargetChange"
          />
        </el-form-item> -->

				<h3 style="margin: 20px 0 10px;">月度目标完成额度</h3>
				<div class="monthly-grid">
					<div v-for="month in 12" :key="month" class="monthly-item">
						<div class="month-label">{{ month }}月</div>
						<el-input-number v-model="targetForm.monthlyTargets[month-1]" :min="0" :precision="2"
							:step="100" style="width: 100%" @change="handleMonthlyTargetChange" />
					</div>
				</div>

				<!-- <div v-if="showMonthlySumWarning" class="warning-message">
          月度目标总和与年度目标不一致
        </div> -->
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="targetDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitTargetForm" :loading="targetSubmitting">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		ref,
		reactive,
		onMounted,
		computed
	} from 'vue'
	import {
		useRoute,
		useRouter
	} from 'vue-router'
	import {
		ElMessage
	} from 'element-plus'
	import {
		getUserDetail,
		updateUser,
		changePassword
	} from '@/api/user'
	import {
		getDepartmentTree
	} from '@/api/department'
	import {
		editAnnualPlan
	} from '@/api/annualPlan'

	export default {
		name: 'UserDetail',
		components: {
		},
		setup() {
			const route = useRoute()
			const router = useRouter()
			const formRef = ref(null)
			const passwordFormRef = ref(null)
			const loading = ref(false)
			const saveLoading = ref(false)
			const planLoading = ref(false)
			const departmentTree = ref([])
			const annualPlan = ref(null)
			const targetDialogVisible = ref(false)
			const targetLoading = ref(false)
			const targetSubmitting = ref(false)
			const targetFormRef = ref(null)

			// 计算月度目标数据
			const monthlyTargets = computed(() => {
				if (!annualPlan.value) return []
				return annualPlan.value.monthlyTargets.map((amount, index) => ({
					month: index + 1,
					amount: amount
				}))
			})

			// 格式化金额
			const formatAmount = (amount) => {
				if (!amount && amount !== 0) return '¥0.00'
				return `¥${Number(amount).toFixed(2)}`
			}

			// 获取用户年度计划
			// const fetchAnnualPlan = async () => {
			//   planLoading.value = true
			//   try {
			//     const params = {
			//       targetId: route.params.id,
			//       planType: 3, // 员工计划
			//       year: new Date().getFullYear()
			//     }
			//     const res = await getUserAnnualPlan(params)
			//     annualPlan.value = res.data
			//   } catch (error) {
			//     console.error('获取年度计划失败:', error)
			//     ElMessage.error('获取年度计划失败')
			//   } finally {
			//     planLoading.value = false
			//   }
			// }

			const userForm = reactive({
				id: '',
				username: '',
				mobile: '',
				email: '',
				deptId: null,
				deptName: '',
				position: '',
				newPassword: '',
				confirmPassword: ''
			})

			const validateConfirmPassword = (rule, value, callback) => {
				if (value !== userForm.newPassword) {
					callback(new Error('两次输入的密码不一致'))
				} else {
					callback()
				}
			}

			const rules = {
				mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					},
					{
						pattern: /^1[3-9]\d{9}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}
				],
				email: [{
					type: 'email',
					message: '请输入正确的邮箱地址',
					trigger: 'blur'
				}],
				deptId: [{
					required: true,
					message: '请选择部门',
					trigger: 'change'
				}],
				newPassword: [{
					min: 6,
					message: '密码长度不能小于6位',
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: validateConfirmPassword,
					trigger: 'blur'
				}]
			}

			const fetchUserDetail = async () => {
				loading.value = true
				try {
					const res = await getUserDetail(route.params.id)
					Object.assign(userForm, res.data)
				} catch (error) {
					console.error('获取用户详情失败:', error)
					ElMessage.error('获取用户详情失败')
				} finally {
					loading.value = false
				}
			}

			const fetchDepartmentTree = async () => {
				try {
					const res = await getDepartmentTree()
					departmentTree.value = res.data
				} catch (error) {
					console.error('获取部门树形数据失败:', error)
					ElMessage.error('获取部门树形数据失败')
				}
			}

			const handleDepartmentChange = (value) => {
				const department = departmentTree.value.find(dept => dept.deptId === value)
				if (department) {
					userForm.deptName = department.deptName
				}
			}

			const handleSave = async () => {
				if (!formRef.value) return

				try {
					await formRef.value.validate()
					await passwordFormRef.value.validate()
					saveLoading.value = true

					// 更新基本信息
					const updateData = {
						id: userForm.id,
						mobile: userForm.mobile,
						email: userForm.email,
						deptId: userForm.deptId,
						deptName: userForm.deptName,
						position: userForm.position
					}
					await updateUser(updateData)

					// 如果设置了新密码，则更新密码
					if (userForm.newPassword) {
						await changePassword({
							userId: userForm.id,
							newPassword: userForm.newPassword
						})
					}

					ElMessage.success('保存成功')
					router.push('/user')
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('保存失败:', error)
				} finally {
					saveLoading.value = false
				}
			}

			const goBack = () => {
				router.back()
			}

			const targetForm = reactive({
				year: new Date().getFullYear(),
				planType: 3,
				targetId: '',
				annualTarget: 0,
				monthlyTargets: Array(12).fill(0)
			})

			const targetRules = {
				annualTarget: [{
						required: true,
						message: '请输入年度目标金额',
						trigger: 'blur'
					},
					{
						type: 'number',
						min: 0,
						message: '金额必须大于0',
						trigger: 'blur'
					}
				]
			}

			// 计算月度目标总和
			const monthlySum = computed(() => {
				return targetForm.monthlyTargets.reduce((sum, target) => sum + target, 0)
			})

			// 显示月度目标总和警告
			const showMonthlySumWarning = computed(() => {
				return Math.abs(monthlySum.value - targetForm.annualTarget) > 0.01
			})

			// 处理年度目标变更
			const handleAnnualTargetChange = () => {
				if (targetForm.annualTarget > 0) {
					const monthlyTarget = targetForm.annualTarget / 12
					targetForm.monthlyTargets = Array(12).fill(Number(monthlyTarget.toFixed(2)))
				}
			}

			// 处理月度目标变更
			const handleMonthlyTargetChange = () => {
				// 可以在这里添加月度目标变化时的逻辑
			}

			// 打开编辑目标对话框
			const handleEditTarget = () => {
				if (userForm.target) {
					targetForm.targetId = userForm.id
					targetForm.annualTarget = userForm.target.annualTarget
					targetForm.monthlyTargets = userForm.target.monthlyTargets1
				}
				targetDialogVisible.value = true
			}

			// 提交目标表单
			const submitTargetForm = async () => {
				if (!targetFormRef.value) return

				try {
					await targetFormRef.value.validate()
					// if (showMonthlySumWarning.value) {
					//   ElMessage.warning('月度目标总和与年度目标不一致')
					//   return
					// }

					targetSubmitting.value = true
					await editAnnualPlan(targetForm)
					ElMessage.success('保存成功')
					targetDialogVisible.value = false
					// 刷新用户详情
					await fetchUserDetail()
				} catch (error) {
					console.error('保存失败:', error)
					ElMessage.error('保存失败')
				} finally {
					targetSubmitting.value = false
				}
			}

			onMounted(() => {
				fetchUserDetail()
				fetchDepartmentTree()
				// fetchAnnualPlan()
			})

			return {
				formRef,
				passwordFormRef,
				loading,
				saveLoading,
				planLoading,
				userForm,
				rules,
				departmentTree,
				annualPlan,
				monthlyTargets,
				formatAmount,
				handleDepartmentChange,
				handleSave,
				goBack,
				targetDialogVisible,
				targetLoading,
				targetSubmitting,
				targetFormRef,
				targetForm,
				targetRules,
				showMonthlySumWarning,
				handleEditTarget,
				handleAnnualTargetChange,
				handleMonthlyTargetChange,
				submitTargetForm
			}
		}
	}
</script>

<style scoped>
	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		padding: 0 10px;
	}

	.header-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.header-left h2 {
		margin: 0;
		font-size: 24px;
		font-weight: 600;
		color: #303133;
	}

	.user-id {
		font-size: 13px;
		padding: 2px 8px;
	}

	.header-actions {
		display: flex;
		gap: 12px;
	}

	.detail-card {
		margin-bottom: 20px;
		border-radius: 8px;
		transition: all 0.3s ease;
	}

	.detail-card:hover {
		transform: translateY(-2px);
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 4px;
	}

	.header-title {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
	}

	.user-form,
	.password-form {
		padding: 20px 0;
	}

	:deep(.el-form-item__label) {
		font-weight: 500;
		color: #606266;
	}

	:deep(.el-input__wrapper) {
		box-shadow: 0 0 0 1px #dcdfe6 inset;
	}

	:deep(.el-input__wrapper:hover) {
		box-shadow: 0 0 0 1px #c0c4cc inset;
	}

	:deep(.el-input__wrapper.is-focus) {
		box-shadow: 0 0 0 1px #409eff inset !important;
	}

	:deep(.el-input__prefix) {
		color: #909399;
	}

	.disabled-input {
		:deep(.el-input__wrapper) {
			background-color: #f5f7fa;
		}
	}

	.department-select {
		width: 100%;
	}

	:deep(.el-tree-select__wrapper) {
		width: 100%;
	}

	:deep(.el-form-item.is-error .el-input__wrapper) {
		box-shadow: 0 0 0 1px #f56c6c inset;
	}

	:deep(.el-form-item.is-error .el-input__wrapper:hover) {
		box-shadow: 0 0 0 1px #f56c6c inset;
	}

	:deep(.el-form-item.is-error .el-input__wrapper.is-focus) {
		box-shadow: 0 0 0 1px #f56c6c inset !important;
	}

	@media screen and (max-width: 768px) {
		.page-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 16px;
		}

		.header-actions {
			width: 100%;
			justify-content: flex-end;
		}

		.el-col {
			width: 100%;
		}
	}

	.monthly-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 16px;
		margin-top: 16px;
	}

	.monthly-item {
		background: #f8f9fa;
		border-radius: 8px;
		padding: 12px;
		text-align: center;
		transition: all 0.3s ease;
	}

	.monthly-item:hover {
		transform: translateY(-2px);
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	}

	.month-label {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 8px;
	}

	.month-amount {
		font-size: 18px;
		color: #409eff;
		margin-bottom: 4px;
	}

	.month-percentage {
		font-size: 14px;
		color: #909399;
	}

	@media screen and (max-width: 768px) {
		.monthly-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.warning-message {
		color: #ff4d4f;
		margin: 10px 0;
		padding: 10px;
		background: #fff2f0;
		border: 1px solid #ffccc7;
		border-radius: 4px;
	}
</style>